import React from 'react';
import { Server } from '../../server/server';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css';
import { Navigate } from 'react-router-dom';
import MessageModal from '../modals/MessageModal';
import { AppConfig } from '../AppConfig';
import AlertModal from '../modals/AlertModal';
import { isLocalHost } from '../util/util';

interface CommunityInvitesPageState {
  invites: any[];
  email: string;
  name: string;
  note: string;
  message: string;
  alert: string;
  loading: boolean;
}

class CommunityInvitesPage extends React.Component<{} , CommunityInvitesPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      invites: [],
      email: '',
      name: '',
      note: '',
      message: '',
      alert: '',
      loading: false
    }
  }

  componentDidMount(): void {
    let email = sessionStorage.getItem('InviteMember');
    if(email && email.indexOf('@') !== -1) 
      this.setState({email: email});
    sessionStorage.removeItem('InviteMember');

    this.loadInvites();
  }

  loadInvites() {
    this.setState({loading: true});

    setTimeout(async () => {
      let response = await Server.user.getCommunityInvites();
      if(response.success)
        this.setState({invites: response.invites});
      this.setState({loading: false})
    }, 500);
  }

  onSend() {
    if(this.state.email.length == 0 || this.state.email.indexOf('.') == -1 || this.state.email.indexOf('@') == -1) {
      this.setState({alert: 'Email address is not valid.'});
      return;
    }

    this.setState({message: 'Sending invite...'});

    setTimeout(async () => {
      let response = await Server.user.sendCommunityInvite({
        email: this.state.email, 
        message: this.state.note, 
        sender: Server.user.getName(),
        title: AppConfig.title,
        slug: AppConfig.community.slug,
        name: this.state.name,
        logo: AppConfig.community.logo,
        sendEmail: isLocalHost() ? false : true
      })

      if(response.success) {
        this.loadInvites();
        this.setState({alert: 'Invitation sent!', message: ''});
      }
      else {
        this.setState({alert: response.message, message: ''});
      }
    }, 500);
  }

  renderInvites() {
    if(this.state.loading) {
      return (
        <div className="site-page-panel">
          <div>Loading previous invites...</div>
        </div>
      )
    }

    if(this.state.invites.length == 0) 
      return null;

    let divs = [];
    for(let i = 0; i < this.state.invites.length; i++) {
      let invite = this.state.invites[i];
      let date = new Date(invite.date);
      divs.push(
        <div key={i} className="site-page-row" style={{justifyContent: 'space-between'}}>
          <div>
            <div><b>{invite.email}</b></div>
            <div className="site-page-subtext">
              Sent {date.toLocaleString(undefined, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"})}
            </div>
          </div>
          <div>
            {invite.state}            
          </div>
        </div>
      )
    }

    return (
      <div className="site-page-panel">
        <div>Invitations you have already sent:</div>
        <div className="site-page-column">
          {divs}
        </div>
      </div>
    )
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    return (
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column">
            <div className="site-page-panel">
              <div>Enter the email address of the person you want to invite:</div>
              <input value={this.state.email} onChange={(e:any)=>this.setState({email: e.currentTarget.value})}/>
              <div style={{textAlign: 'right'}}>
                <button onClick={()=>this.onSend()}>Send Invite Email</button>
              </div>
            </div>
            {this.renderInvites()}
          </div>
        </PageEnvelope>
        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    )
  }
}

export default CommunityInvitesPage;